// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"d7d7040d","787":"5b805540"}[chunkId] + ".chunk.js";
};